import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSliderModule } from '@angular/material/slider';

import { FormChoiceSliderComponent } from './form-choice-slider.component';

export const imports: NgModule['imports'] = [FlexLayoutModule, MatFormFieldModule, MatSliderModule, ReactiveFormsModule];

@NgModule({
  declarations: [FormChoiceSliderComponent],
  imports: [...imports, CommonModule],
  exports: [FormChoiceSliderComponent],
})
export class FormChoiceSliderModule {}
